import { useEffect, useState } from 'react';
import { FileField } from '../../../components/field/field';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { toast } from '../../../util/toasts';
import { S3Image } from '../../../components/image/s3-image';
import { Spinner } from '../../../components/spinner/spinner';

export const InvoiceLogoUpload = () => {
  const { uploadToS3, getInvoiceLogoUploadUrl } = useAPI();
  const [invoiceLogo, setInvoiceLogo] = useState<File>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const uploadPlaceholder = async () => {
    if (invoiceLogo) {
      try {
        setIsLoading(true);
        const url = await getInvoiceLogoUploadUrl(invoiceLogo.name);
        await uploadToS3(url, invoiceLogo);
        setInvoiceLogo(undefined);
        toast('Invoice logo uploaded successfully', 'success');
        setIsLoading(false);
      } catch (e) {
        toast('Failed to upload invoice logo', 'error');
      }
    }
  };

  useEffect(() => {
    uploadPlaceholder();
  }, [invoiceLogo]);

  return isLoading ? (
    <Spinner />
  ) : (
    <div>
      <p>
        <i>The desktop logo will be displayed on contracts and invoices if a different logo is not uploaded.</i>
      </p>
      <FileField
        onChange={(f) => setInvoiceLogo(f as File)}
        multiple={false}
        accept="image/jpeg, image/png"
        value={invoiceLogo}
      />
      <br />
      <br />
      <div className="p-2 w-fit">
        <S3Image className="w-fit" s3Key="logos/invoice_logo" onError="hide" />
      </div>
    </div>
  );
};
